import '@/mikan/_shared/lib/polyfills';
import '@/mikan/_shared/plugins/alertBox';
import Vue from 'vue';
import registerRollbar from '@/mikan/_shared/plugins/registerRollbar';
import viewModelRegister from '@/mikan/_shared/lib/utilities/viewModelRegister';

import commonComponents from '@/mikan/pc/entries/commonComponents';

Vue.config.productionTip = false;
registerRollbar(Vue);

viewModelRegister(commonComponents);
